import React, { useEffect, useRef, useState } from 'react';
import { PageStyled } from './index.styles';
import VoteNumber from 'components/vote-number';
import Icon from '@mui/material/Icon';
import MiniAlert from 'components/mini-alert';
import { ChevronRight, LocalHotel, PublishedWithChanges } from '@mui/icons-material';
import { Box, Button, Rating, Skeleton } from '@mui/material';
import { convertToSlug } from 'common/utils';
import LazyImage from 'components/lazy-image';
import HotelFeatures from 'components/hotel/hotel-features';
// import { routesPaths } from 'config/routes';
// import i18n from 'assets/i18n';
import moment from 'moment';
import { routesPaths } from 'config/routes';
import i18n from 'assets/i18n';
import CurrencyPrice from 'components/currency-price';
import { t } from 'i18next';

interface HotelTicketCardProps {
    data?: any;
    params?: any;
    hotelDetailCallBack?: (data: any) => void;
    isActiveId?: number;
}

const MapTicketCard: React.FC<HotelTicketCardProps> = ({ data, params, hotelDetailCallBack, isActiveId = 0 }) => {
    const elementRef = useRef<HTMLDivElement | null>(null);
    const [isVisible, setVisible] = useState(false);

    let parameter: string = '';
    if (params) {
        parameter = `checkInDate=${params.start_date}&checkOutDate=${params.end_date}&guest=${params.adults}`;
        if (params.children.length > 0) {
            parameter += `&child=${params.children.join(',')}`;
        }
        parameter += `&shopId=${data.shopping_file_id}`;
    }

    const url = data
        ? `${routesPaths[i18n.language].hotelDetails}/${convertToSlug(data.title)}-F${data.id}?${parameter}`
        : '';

    useEffect(() => {
        const observer = new IntersectionObserver((enteries) => {
            enteries.forEach((entery: IntersectionObserverEntry) => {
                setVisible(entery.isIntersecting);
            });
        });
        elementRef.current && observer.observe(elementRef.current);
        return () => {
            observer.disconnect();
        };
    }, [elementRef.current]);

    const WebTicketCard = () => {
        return data ? (
            <div className="ticket-card">
                <div className="row">
                    <div className="column-1">
                        <div className="thumbnail">
                            {data.rating > 0 && (
                                <div className="thumbnail-badge">
                                    <Rating
                                        className="ticket-rating"
                                        max={Math.floor(data.rating)}
                                        name="read-only"
                                        size="small"
                                        value={Math.floor(data.rating)}
                                        readOnly
                                    />
                                </div>
                            )}
                            <div className="thumbnail-vote">
                                <VoteNumber
                                    vote={data.vote}
                                    color="secondary"
                                    size="small"
                                    voteAlign="right"
                                    textHide={true}
                                />
                            </div>
                            <LazyImage
                                src={`${data.thumbnail}`}
                                alt={data.title}
                                fallbackSrc="/assets/images/loading.gif"
                            />
                        </div>
                    </div>
                    <Box display="flex" flexDirection="column" flex={1} sx={{ width: 'calc(100% - 100px)' }}>
                        <div className="column-2">
                            <div className="ticket-title">{data.title}</div>
                            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                                <Box display={'flex'} flexDirection={'column'} gap={1}>
                                    <div className="location">
                                        <Box display="flex" alignItems="center" gap="5px">
                                            <Icon>map</Icon>
                                            <span>{data.location}</span>
                                        </Box>
                                    </div>
                                    {data.room_label && (
                                        <div className="hotel-feature">
                                            <HotelFeatures
                                                icon={<LocalHotel />}
                                                iconColor="primary"
                                                background={true}
                                                text={data.room_label}
                                            />
                                        </div>
                                    )}
                                    <div className="alert-box">
                                        <MiniAlert
                                            size="small"
                                            showIcon
                                            icon={<PublishedWithChanges />}
                                            state={'success'}
                                            text={t('hotel.widgets.map.mapTicketCard.freeCancel')}
                                        />
                                        {data.room_size < 6 && (
                                            <MiniAlert
                                                size="small"
                                                state={'error'}
                                                text={`${t('hotel.widgets.map.mapTicketCard.last')} ${
                                                    data.room_size
                                                } ${t('hotel.widgets.map.mapTicketCard.room')}`}
                                            />
                                        )}
                                    </div>
                                </Box>
                                <Box
                                    display={'flex'}
                                    flexDirection={'column'}
                                    gap={1}
                                    justifyContent={'space-between'}
                                    alignContent={'flex-end'}
                                ></Box>
                            </Box>
                        </div>
                        <div className="column-3">
                            <div className="bottom-box">
                                <div className="left">
                                    {params && (
                                        <div className="guest-info">
                                            <span style={{ whiteSpace: 'nowrap' }}>
                                                {moment(params.end_date).diff(moment(params.start_date), 'days')}{' '}
                                                {t('hotel.widgets.map.mapTicketCard.night')},
                                            </span>{' '}
                                            <span style={{ whiteSpace: 'nowrap' }}>
                                                {params.adults} {t('hotel.widgets.map.mapTicketCard.passengerText.ADT')}
                                            </span>
                                            <span style={{ whiteSpace: 'nowrap' }}>
                                                {params.children.length > 0
                                                    ? ', ' +
                                                      params.children.length +
                                                      ' ' +
                                                      t('hotel.widgets.map.mapTicketCard.passengerText.CHD')
                                                    : ''}
                                            </span>
                                        </div>
                                    )}

                                    <div className="price-box">
                                        {data.discount > 0 && (
                                            <div className="old-price">
                                                <CurrencyPrice
                                                    price={data.discount_price}
                                                    symbol={data.price_currency}
                                                    fontSize={12}
                                                    line={true}
                                                    fontWeight={true}
                                                    color="#d32f2f"
                                                    noCalculate={true}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="price-box">
                                        <div className="ticket-price">
                                            <CurrencyPrice
                                                price={data.now_price}
                                                fontSize={16}
                                                symbol={data.price_currency}
                                                fontWeight={true}
                                                noCalculate={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="right">
                                    {data.discount > 0 && (
                                        <div className="price-discount">
                                            <Box display="flex" alignItems="center" gap="5px">
                                                <Icon>local_offer</Icon>
                                                <span>
                                                    %{Number(data.discount).toFixed(0)}{' '}
                                                    {t('hotel.widgets.map.mapTicketCard.discount')}
                                                </span>
                                            </Box>
                                        </div>
                                    )}
                                    <div className="buttons">
                                        <Button
                                            href={url}
                                            target="_blank"
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            endIcon={<ChevronRight />}
                                        >
                                            {t('hotel.widgets.map.mapTicketCard.button.choose')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
        ) : (
            <WebTicketCardSkeleton />
        );
    };

    const WebTicketCardSkeleton = () => {
        return (
            <div className="ticket-card web">
                <div className="column-1">
                    <Skeleton animation="wave" variant="rectangular" width={230} height={230} />
                </div>
                <div className="column-2">
                    <Skeleton animation="wave" width={'70%'} height={25} />
                    <div className="location">
                        <Box display="flex" alignItems="center" gap="5px">
                            <Skeleton animation="wave" width={'80%'} height={25} />
                        </Box>
                    </div>
                    <div className="location-km">
                        <Box display="flex" alignItems="center" gap="5px">
                            <Skeleton animation="wave" width={'50%'} height={25} />
                        </Box>
                    </div>
                    <div className="">
                        <Skeleton animation="wave" width={'25%'} height={25} />
                    </div>
                    <Box display="flex" alignItems="center" gap="5px">
                        <Skeleton animation="wave" variant="circular" width={25} height={25} />
                        <Skeleton animation="wave" variant="circular" width={25} height={25} />
                        <Skeleton animation="wave" variant="circular" width={25} height={25} />
                        <Skeleton animation="wave" variant="circular" width={25} height={25} />
                    </Box>
                    <div className="alert-box">
                        <Skeleton animation="wave" width={50} height={25} />
                        <Skeleton animation="wave" width={50} height={25} />
                    </div>
                </div>
                <div className="column-3">
                    <div className="votes">
                        <Skeleton animation="wave" width={120} height={28} />
                    </div>
                    <div className="bottom-box">
                        <div className="guest-info">
                            <Skeleton animation="wave" width={120} height={36} />
                        </div>

                        <div className="price-box">
                            <div className="ticket-price">
                                <Skeleton animation="wave" width={90} height={28} />
                            </div>
                        </div>
                        <div className="buttons">
                            <Skeleton animation="wave" variant="rounded" width={130} height={36} />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <PageStyled>
            <div
                className={`ticket ${isVisible ? 'fade-in' : ''} ${isActiveId === data.id && 'active'}`}
                ref={elementRef}
                onClick={() => {
                    hotelDetailCallBack && hotelDetailCallBack(data);
                }}
            >
                <WebTicketCard />
            </div>
        </PageStyled>
    );
};

export default MapTicketCard;
